interface State {
  popup: any;
}

const state: State = {
  popup: {
    title: '',
    text: ''
  }
};

const getters = {
  popup: (state: State) => state.popup
};

const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  mutations
};
